import {inject, injectable} from "inversify";
import {GroundSlot} from "@/modules/club-grounds/entity";
import {BankCategory} from "@/modules/finances/enums";
import {EventEmitter} from "@/modules/base/events";
import {Season} from "@/modules/season/entity";
import {GroundSlotTypeEnum} from "@/modules/club-grounds/enums";
import {BeforeGroundSlotFinishedEvent} from "@/modules/club-grounds/events/BeforeGroundSlotFinishedEvent";
import {AfterGroundSlotFinishedEvent} from "@/modules/club-grounds/events/AfterGroundSlotFinishedEvent";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import GateManager from "@/modules/action-points/services/GateManager";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class SlotDeveloper {
  constructor(
    @inject(GateManager) private gateManager: GateManager,
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  public async finish(slot: GroundSlot) {
    await this.em.emitAsync(new BeforeGroundSlotFinishedEvent(slot));

    slot.developedAt = null;
    await slot.save();

    await this.em.emitAsync(new AfterGroundSlotFinishedEvent(slot));
  }

  public async queue(slot: GroundSlot, type: GroundSlotTypeEnum) {
    if (slot.type) {
      throw 'Ground slot has a type already.';
    }

    if (slot.developedAt) {
      throw 'Ground slot build is queued already .';
    }

    const season = await Season.current();
    const duration = this.configRepository.get('clubGrounds.durations.develop')(slot, type);
    const price = this.configRepository.get('clubGrounds.costs.develop')(slot, type);

    await this.gateManager.getGate(GateTypeEnum.BALANCE).currency.subtract(
      price,
      {
        category: BankCategory.CLUB_GROUNDS,
        label: translator.t('unlocked_club_grounds'),
      }
    );

    slot.type = type;
    slot.developedAt = season.currentDate.add(duration, 'days').toDate();
    await slot.save();
  }
}
